/*@flow*/
import * as I from 'immutable';
import getBbox from 'lib/getBbox';
import { q, state } from 'ops';

function getMap() {
  return window.cityMap || window.districtMap;
}
const getZoom = () => getMap().getZoom();

const queryUpdater = (v) => {
  v = I.fromJS(v || I.Map());
  const bbox = getBbox();
  const zoom = getZoom();
  const updater = (v2) => {
    v2 = bbox ? v2.setIn(['filter', 'bbox'], bbox) : v2;
    v2 = zoom ? v2.setIn(['mapConfig', 'zoom'], zoom) : v2;
    return v2;
  };
  return state('$queryInitialized') ? v.update(updater) : v;
};

export default function updateFilterQuery() {
  q(queryUpdater);
}
